<script lang="ts">
    import Icon from "../../../widgets/Icon.svelte"
    import { Datepicker } from "vanillajs-datepicker"
    import { mdiCalendarAccount, mdiCalendarRemove } from "@mdi/js"

    export let classList = "",
        dateValue: Date,
        placeholder: string,
        id: string,
        disabled = false,
        editMode = true

    let datepicker: Datepicker
    let wrapper: HTMLLabelElement
    function getElementPosition(
        element: HTMLElement,
        options: {
            minSpace: number
            offsetAbove: number
        } = { minSpace: 150, offsetAbove: 75 }
    ): {
        x: string
        y: string
    } {
        const rect = element.getBoundingClientRect()
        const scrollTop = window.scrollY || window.pageYOffset
        const windowHeight = window.innerHeight
        const topBody = Number(document.body.style.top.split("px")[0])
        let top = rect.bottom + scrollTop + 5 - topBody

        // Check if there's the specified minimum visible space below the element
        if (windowHeight - rect.bottom < options.minSpace) {
            // Place the element above the current element with the specified offset
            top = rect.top + scrollTop - element.offsetHeight - options.offsetAbove - topBody + 100
        }
        return {
            y: top + "px",
            x: window.innerWidth - rect.right - 20 + "px",
        }
    }

    function respawnElement(element: HTMLElement, deepCopy: boolean = true) {
        var newElement = element.cloneNode(deepCopy)
        element.parentNode.replaceChild(newElement, element)
        return newElement
    }

    function hideAllModals() {
        const dateModal = document.getElementById("dateModal")
        dateModal.style.display = "none"
        respawnElement(dateModal, false)
    }

    function outSideDateModalClickListener(e: MouseEvent) {
        const dateModal = document.getElementById("dateModal")
        if (
            !dateModal.contains(e.target as Node) &&
            e.target !== document &&
            !(e.target as Element).classList.contains("datepicker-cell")
        ) {
            hideDatepicker()
        }
    }
    function dateChangeListener(e: any) {
        dateValue = new Date(e.detail.date)
        hideDatepicker()
    }

    function hideDatepicker() {
        const dateModal = document.getElementById("dateModal")
        dateModal.style.display = "none"
        datepicker?.destroy()

        dateModal.removeEventListener("changeDate", dateChangeListener)
        document.removeEventListener("click", outSideDateModalClickListener)
    }

    function showDatepicker() {
        let dateModal = document.getElementById("dateModal")
        hideAllModals()
        if (datepicker) hideDatepicker()
        dateModal = document.getElementById("dateModal")
        dateModal.style.display = "block"
        dateModal.style.top = getElementPosition(wrapper, { minSpace: 300, offsetAbove: 300 }).y
        dateModal.style.right = getElementPosition(wrapper, { minSpace: 300, offsetAbove: 300 }).x
        datepicker = new Datepicker(dateModal, {})
        if (dateValue) datepicker.setDate(dateValue)
        dateModal.addEventListener("changeDate", dateChangeListener)
        document.addEventListener("click", outSideDateModalClickListener)
    }
</script>

<label
    bind:this="{wrapper}"
    id="{id}"
    class="custom-date-picker"
>
    <span class:hasValue="{!!dateValue || !editMode}">{placeholder}</span>
    {#if editMode}
        <div class="wrapper">
            {#if dateValue}
                <button
                    data-cy="custom-date-picker-text"
                    class="btn text transparent"
                    on:click|preventDefault|stopPropagation="{showDatepicker}"
                >
                    {new Date(dateValue).toLocaleDateString("de-DE")}
                </button>
            {:else}
                <div style="opacity: 0.75;">{placeholder}</div>
            {/if}

            <button
                data-cy="custom-date-picker-icon"
                class="btn transparent icon"
                on:click|preventDefault|stopPropagation="{() => {
                    hideAllModals()
                    if (dateValue) dateValue = null
                    else showDatepicker()
                }}"
            >
                {#if !dateValue}
                    <Icon
                        path="{mdiCalendarAccount}"
                        width="24px"
                        height="24px"
                    />
                {:else}
                    <Icon
                        path="{mdiCalendarRemove}"
                        width="24px"
                        height="24px"
                    />
                {/if}
            </button>
        </div>{:else if !editMode}
        {#if dateValue}
            <div class="no-input">
                {new Date(dateValue).toLocaleDateString("de-DE")}
            </div>
        {:else}
            <div class="no-input">-</div>
        {/if}
    {/if}
</label>

<style lang="less">
    @import "vanillajs-datepicker/css/datepicker.css";
    :global .hiddenscript {
        opacity: 0;
        position: absolute;
    }
    .custom-date-picker {
        min-height: 100% !important;
        flex-grow: 1;
        height: 24px;
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: space-between;
        .wrapper {
            display: flex;
            justify-content: space-between;
            .btn.icon,
            .btn.text {
                display: flex;
                align-items: center;
                color: var(--text-invers-100);

                &.text {
                    color: var(--text-invers-100);
                }
            }
            .icon {
                opacity: 0.75;
            }
        }
    }
</style>
